import React, { useState, useRef, useEffect } from 'react'
import { useSpring, animated } from 'react-spring'

import { useStyles } from './line-marker.style'
import { colors } from '../../common/colors'

export function LineMarker ({ label, verticalMarkerAt, scales, height, mouseXPosition, markerPadding }) {
  const classes = useStyles()
  const labelRef = useRef()
  const labelWidth = useRef()
  const [showMarker, setShowMarker] = useState(true)

  const springProps = useSpring({
    from: { opacity: 0 },
    to: { opacity: 1 },
    reverse: !showMarker
  })

  useEffect(() => {
    if (labelRef.current) {
      const boundingClientRect = labelRef.current.getBoundingClientRect()
      labelWidth.current = boundingClientRect.width
    }
  }, [])

  useEffect(() => {
    if (mouseXPosition !== undefined) {
      const lineMarkerPadding = markerPadding === undefined ? (labelWidth.current * 1.5) / 2 : markerPadding
      const left = verticalMarkerXPosition - lineMarkerPadding
      const right = verticalMarkerXPosition + lineMarkerPadding
      const shouldShowMarker = (mouseXPosition > right) || (mouseXPosition < left)
      setShowMarker(shouldShowMarker)
    }
  }, [mouseXPosition])

  const verticalMarkerXPosition = scales.x(verticalMarkerAt)

  if (verticalMarkerAt === undefined) {
    return null
  }

  return (
    <g>
      <animated.text className={classes.text} y={-7} x={verticalMarkerXPosition} ref={labelRef} style={springProps}>
        {label}
      </animated.text>
      <line
        y1={0}
        y2={height}
        stroke={colors.gunMetal}
        strokeWidth={1}
        strokeDasharray="5,4"
        x1={verticalMarkerXPosition}
        x2={verticalMarkerXPosition} />
    </g>
  )
}
